import { Route, Routes } from "react-router-dom";

import PageTitle from "@common/PageTitle";

import NotificationMainPage from "@pages/Notification/NotificationMainPage";
import ViewNotificationPage from "@pages/Notification/ViewNotificationPage";
import CreateNotificationPage from "@pages/Notification/CreateNotificationPage";

import ViewTenantPage from "@pages/Tenant/ViewTenantPage";

import HubMainPage from "@pages/WORKJOY/HubMainPage";
import HomeMainPage from "@pages/Home/HomeMainPage";

import CreateUserPage from "@pages/User/CreateUserPage";
import KakelyCsvUploadPage from "@pages/KAKELY/KakelyCsvUploadPage";
import CreateExternalPhonebookPage from "@pages/KAKELY/CreateExternalPhonebookPage";

import UserMainPage from "@pages/User/UserMainPage";
import ViewExternalPhonebookPage from "@pages/KAKELY/ViewExternalPhonebookPage";
import ViewUserPage from "@pages/User/ViewUserPage";
import ViewCurrentUserPage from "@pages/User/ViewUserPage";
import UserCSVUploadPage from "@pages/User/UserCsvUploadPage";
import UserPhotoUploadPage from "@pages/User/UserPhotoUploadPage";
import PasswordResetPage from "@pages/User/PasswordResetPage";

import AISettingsPage from "@pages/WORKJOY/AISettingsPage";
import BiToolPage from "@pages/WORKJOY/BiToolPage";

import YobelyGroupMainPage from "@pages/YOBELY/YobelyGroupMainPage";
import CreateYobelyGroupPage from "@pages/YOBELY/CreateYobelyGroupPage";
import EditYobelyGroupPage from "@pages/YOBELY/EditYobelyGroupPage";
import CreateTenantPage from "@pages/Tenant/CreateTenantPage";

import DepartmentGroupMainPage from "@pages/KAKELY/DepartmentGroupMainPage";
import EditDepartmentGroupPage from "@pages/KAKELY/EditDepartmentGroupPage";
import CreateDepartmentGroupPage from "@pages/KAKELY/CreateDepartmentGroupPage";

import StampSettingsPage from "@pages/WORKJOY/StampSettingsPage";
import MentalHealthPage from "@pages/WORKJOY/MentalHealthPage";

import PrivateRoute from "@components/Routes/PrivateRoute";
import NotFound from "@components/ErrorPages/PageNotFound";
import AdminRoute from "@components/Routes/AdminRoute";
import TenantAdminPage from "@pages/Tenant/TenantAdminPage";
import ContractRoute from "@components/Routes/ContractRoute";
import KakelyExternalContactMainPage from "@pages/KAKELY/KakelyExternalContactMainPage";
import RegularRoute from "@components/Routes/RegularRoute";
import {
  TENANT_PATHS,
  GENERIC_PATHS,
  KAKELY_PATHS,
  NOTIFICATION_PATHS,
  USER_PATHS,
  WORKJOY_PATHS,
  YOBELY_PATHS,
} from "@constants/NavigationPaths";
import { pageTitles } from "@constants/PageTitles";
import { APP_NAMES } from "@constants/Enums";
import KakelyInternalContactMainPage from "../pages/KAKELY/KakelyInternalContactMainPage";
import CreateInternalPhonebookPage from "../pages/KAKELY/CreateInternalPhonebookPage";
import DepartmentGroupCsvUploadPage from "@pages/KAKELY/DepartmentGroupCsvUploadPage";

export const AppRoutes = (form) => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.GENERIC.login} />
                {form.isAdminLoggedIn ? <UserMainPage /> : <HomeMainPage />}
              </>
            )}
          />
        }
      />
      <Route
        path={NOTIFICATION_PATHS.main}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.NOTIFICATION.main} />
                <NotificationMainPage />
              </>
            )}
          />
        }
      />
      <Route
        path={NOTIFICATION_PATHS.newNotification}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.NOTIFICATION.create} />
                <CreateNotificationPage />
              </>
            )}
          />
        }
      />
      <Route
        path={NOTIFICATION_PATHS.viewNotification}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.NOTIFICATION.edit} />
                <ViewNotificationPage />
              </>
            )}
          />
        }
      />
      <Route
        path={NOTIFICATION_PATHS.createNotification}
        element={
          <AdminRoute
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.NOTIFICATION.edit} />
                    <CreateNotificationPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={TENANT_PATHS.listCompanies}
        element={
          <AdminRoute
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.TENANT.main} />
                    <TenantAdminPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={TENANT_PATHS.showCompany}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.TENANT.manage} />
                <ViewTenantPage />
              </>
            )}
          />
        }
      />
      <Route
        path={TENANT_PATHS.manageCompany}
        element={
          <AdminRoute
            element={() => (
              <>
                <PrivateRoute
                  element={() => (
                    <>
                      <PageTitle title={pageTitles.TENANT.manage} />
                      <ViewTenantPage />
                    </>
                  )}
                />
              </>
            )}
          />
        }
      />
      {/* <Route
              path="company/manage/csvUpload"
              element={
                <AdminRoute
                  element={() => (
                    <PrivateRoute
                      element={() => (
                        <>
                          <PageTitle title={`企業CSVアップロード | ${APPNAME}`} />
                          <TenantCsvUploadPage />
                        </>
                      )}
                    />
                  )}
                />
              }
            /> */}
      <Route
        path={TENANT_PATHS.createCompany}
        element={
          <AdminRoute
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.TENANT.create} />
                    <CreateTenantPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={GENERIC_PATHS.settings}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.GENERIC.settings} />
                <ViewCurrentUserPage />
              </>
            )}
          />
        }
      />
      <Route
        path={GENERIC_PATHS.home}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.GENERIC.info} />
                <HomeMainPage />
              </>
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.main}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.mainExternal} />
                    <KakelyExternalContactMainPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.mainInternal}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.mainInternal} />
                    <KakelyInternalContactMainPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.allDepartmentSettings}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.departmentView} />
                    <DepartmentGroupMainPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.departmentSettings}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.departmentSettings} />
                    <EditDepartmentGroupPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.createDepartment}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.departmentSettings} />
                    <CreateDepartmentGroupPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.csvUploadDepartmentGroup}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.departmentCsvUpload} />
                    <DepartmentGroupCsvUploadPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.csvUpload}
        element={
          <RegularRoute
            element={() => (
              <ContractRoute
                appName={APP_NAMES.KAKELY}
                element={() => (
                  <PrivateRoute
                    element={() => (
                      <>
                        <PageTitle title={pageTitles.GENERIC.csvUpload} />
                        <KakelyCsvUploadPage />
                      </>
                    )}
                  />
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.createContact}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.phonebookEdit} />
                    <CreateExternalPhonebookPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.createInternalContact}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.phonebookEdit} />
                    <CreateInternalPhonebookPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={KAKELY_PATHS.showUser}
        element={
          <ContractRoute
            appName={APP_NAMES.KAKELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.KAKELY.phonebookView} />
                    <ViewExternalPhonebookPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={USER_PATHS.main}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.USER.main} />
                <UserMainPage />
              </>
            )}
          />
        }
      />
      <Route
        path={USER_PATHS.showUser}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.USER.edit} />
                <ViewUserPage />
              </>
            )}
          />
        }
      />
      <Route
        path={USER_PATHS.csvUpload}
        element={
          <RegularRoute
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.GENERIC.csvUpload} />
                    <UserCSVUploadPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={USER_PATHS.photoUpload}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.USER.photoUpload} />
                <UserPhotoUploadPage />
              </>
            )}
          />
        }
      />
      <Route
        path={USER_PATHS.createUser}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.USER.create} />
                <CreateUserPage />
              </>
            )}
          />
        }
      />
      <Route
        path={USER_PATHS.passwordReset}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.USER.changePassword} />
                <PasswordResetPage />
              </>
            )}
          />
        }
      />
      <Route
        path={WORKJOY_PATHS.hub}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.WORKJOY.main} />
                <HubMainPage />
              </>
            )}
          />
        }
      />
      <Route
        path={WORKJOY_PATHS.manageMentalCare}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.WORKJOY.manageMentalCare} />
                <MentalHealthPage />
              </>
            )}
          />
        }
      />
      <Route
        path={WORKJOY_PATHS.manageAISettings}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.WORKJOY.manageAISettings} />
                <AISettingsPage />
              </>
            )}
          />
        }
      />
      <Route
        path={WORKJOY_PATHS.manageSettings}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.WORKJOY.manageSettings} />
                <StampSettingsPage />
              </>
            )}
          />
        }
      />
      <Route
        path={WORKJOY_PATHS.biToolSettings}
        element={
          <PrivateRoute
            element={() => (
              <>
                <PageTitle title={pageTitles.WORKJOY.biToolSettings} />
                <BiToolPage />
              </>
            )}
          />
        }
      />
      <Route
        path={YOBELY_PATHS.main}
        element={
          <ContractRoute
            appName={APP_NAMES.YOBELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.YOBELY.main} />
                    <YobelyGroupMainPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={YOBELY_PATHS.editGroup}
        element={
          <ContractRoute
            appName={APP_NAMES.YOBELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.YOBELY.main} />
                    <EditYobelyGroupPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path={YOBELY_PATHS.createGroup}
        element={
          <ContractRoute
            appName={APP_NAMES.YOBELY}
            element={() => (
              <PrivateRoute
                element={() => (
                  <>
                    <PageTitle title={pageTitles.YOBELY.main} />
                    <CreateYobelyGroupPage />
                  </>
                )}
              />
            )}
          />
        }
      />
      <Route
        path="*"
        element={
          <>
            <PageTitle title={pageTitles.GENERIC.not_found} />
            <NotFound />
          </>
        }
      />
    </Routes>
  );
};
